module.exports = __webpack_public_path__ + "img/buyer-item-2-mobile.6aaaf88d.png";